/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { DepartmentsState, initialState } from '@departments/store/departments.state';
import * as DepartmentsActions from './departments.actions';

export function departmentsReducer(
  state = initialState,
  action: DepartmentsActions.DepartmentsActions
): DepartmentsState {
  switch (action.type) {
    case DepartmentsActions.LOAD_DEPARTMENTS_SUCCESS:
      return {
        ...state,
        departments: action.departments,
        isActionPending: false
      };
    case DepartmentsActions.LOAD_DEPARTMENTS:
    case DepartmentsActions.LOAD_DEPARTMENT:
    case DepartmentsActions.PERSIST_DEPARTMENT:
    case DepartmentsActions.DELETE_DEPARTMENT:
      return {
        ...state,
        isActionPending: true
      };
    case DepartmentsActions.LOAD_DEPARTMENT_SUCCESS:
      return {
        ...state,
        isActionPending: false,
        currentDepartment: action.department
      };
    case DepartmentsActions.LOAD_DEPARTMENTS_FAILURE:
    case DepartmentsActions.LOAD_DEPARTMENT_FAILURE:
    case DepartmentsActions.PERSIST_DEPARTMENT_SUCCESS:
    case DepartmentsActions.PERSIST_DEPARTMENT_FAILURE:
    case DepartmentsActions.DELETE_DEPARTMENT_SUCCESS:
    case DepartmentsActions.DELETE_DEPARTMENT_FAILURE:
      return {
        ...state,
        isActionPending: false
      };
    default:
      return state;
  }
}
